<!--
 * @Description: 项目简介组件
 * @Date: 2022-01-25 16:05:22
 * @LastEditTime: 2022-02-21 15:23:21
-->
<template lang="pug">
  div.info-container
    p.info-message {{ infoMessage }}
    p.contact-us(v-html="contactUs")
</template>

<script>
const zhContactUs = '联系电话：400-696-4188';
const enContactUs = 'TEL： 400-696-4188';
export default {
  name: 'video-record',
  data() {
    return {
      infoMessage: '',
      contactUs: '',
    };
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler(val) {
        const desc = sessionStorage.getItem('liveDesc');
        if (val === 'zh') {
          this.infoMessage = desc;
          this.contactUs = zhContactUs;
        } else if (val === 'en') {
          this.infoMessage = desc;
          this.contactUs = enContactUs;
        }
      },
    },
  },
};
</script>

<style lang="stylus" scoped>
  .info-container
    width 100%
    height 100%
    color $grayFontColor
    padding 20px 25px 25px
    font-size 16px
    text-align left
    word-break break-all
    p.contact-us
      margin-top 20px
</style>

<i18n>
{
	"en": {
		"Coming soon": "Coming soon"
	},
	"zh": {
		"Coming soon": ""
	}
}
</i18n>
